import { render, staticRenderFns } from "./UnmatchedSmsReplyMessages.vue?vue&type=template&id=760ef4ce&scoped=true&"
import script from "./UnmatchedSmsReplyMessages.vue?vue&type=script&lang=js&"
export * from "./UnmatchedSmsReplyMessages.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedSmsReplyMessages.vue?vue&type=style&index=0&id=760ef4ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ef4ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VPagination,VRow,VSkeletonLoader,VSubheader,VTextField})
